import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row mt-3" };
const _hoisted_2 = {
    class: "col-12",
    style: { "white-space": "pre-line" }
};
const _hoisted_3 = { class: "row mt-3" };
const _hoisted_4 = { class: "col-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$route.meta.title
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.errorMessage?.error_message), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_g_button, {
                        text: _ctx.$tc('shared.Text.Back'),
                        onClick: _withModifiers(_ctx.onBack, ["stop", "prevent"])
                    }, null, 8, ["text", "onClick"])
                ])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
